module.exports = __webpack_public_path__ + "img/tb(1).ce3ef351.png";